import { render, staticRenderFns } from "./IncludeServing.vue?vue&type=template&id=3520967e&scoped=true"
import script from "./IncludeServing.vue?vue&type=script&lang=ts"
export * from "./IncludeServing.vue?vue&type=script&lang=ts"
import style0 from "./IncludeServing.vue?vue&type=style&index=0&id=3520967e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520967e",
  null
  
)

export default component.exports